<template>
  <transition
    enter-active-class="noop"
    leave-active-class="noop">
    <div class="mb-box" v-show="show">
      <transition
        enter-active-class="bounceIn"
        leave-active-class="bounceOut"
      >
        <div v-if="show" class="mb-container">
          <icon-close class="mb-close" v-if="showClose" @click.native="close" />
          <div class="mb-header" v-if="title">
            <slot name="header">{{title}}</slot>
          </div>
          <div class="mb-content">
            <slot name="content"></slot>
          </div>
          <slot name="footer" v-if="showFooter">
            <div class="mb-footer">
              <button @click="handleCancel" class="mb-cancel" v-if="showCancelBtn || cancelBtnText">{{cancelBtnText}}</button>
              <button @click="handleConfirm" class="mb-confirm" v-if="showConfirmBtn">{{confirmBtnText}}</button>
            </div>
          </slot>
        </div>
      </transition>
      <transition
        enter-active-class="fadeIn"
        leave-active-class="fadeOut">
        <div v-if="show" class="mb-mask"></div>
      </transition>
    </div>
  </transition>
</template>
<script>
import IconClose from '@/assets/svg/icon_close.svg'
export default {
  components: {
    IconClose
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    showFooter: {
      type: Boolean,
      default: true
    },
    showClose: {
      type: Boolean,
      default: true
    },
    confirmBtnText: {
      type: String,
      default: '确定'
    },
    cancelBtnText: {
      type: String,
      default: ''
    },
    showConfirmBtn: {
      type: Boolean,
      default: true
    },
    showCancelBtn: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleConfirm() {
      const { confirm } = this.$listeners
      confirm && confirm()
      this.close()
    },
    handleCancel() {
      const { cancel } = this.$listeners
      cancel && cancel()
      this.close()
    },
    close() {
      this.$emit('update:show', false)
    }
  }
}
</script>

<style lang="scss">
  @import '~@/assets/styles/animation.scss';
</style>

<style lang="scss" scoped>
.mb-box {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 98;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0);
  transition-duration: 0.3s;
}

.mb-mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 97;
  background-color: #000;
  opacity: 0.75;
  transition-duration: 0.3s;
}

.mb-container {
  animation-fill-mode: both;
  width: calc(100% - 130px);
  z-index: 98;
  background-color: #fff;
  background-clip: padding-box;
  border-radius: 10px;
  outline: 0;
  box-shadow: 0px 12px 24px 0px rgba(0, 0, 0, 0.25);
  text-align: left;
  animation-duration: 0.3s;
  position: relative;
}
.mb-header{
  border-bottom: 1px solid #F5F5F5;
  height: 96px;
  line-height: 96px;
  font-size: 34px;
  font-weight: 500;
  color: #333333;
  text-align: center;
  margin-bottom: 30px;
}
.mb-close {
  position: absolute;
  top: 36px;
  right: 36px;
  width: 24px;
  height: 24px;
  fill: #ccc;
}
.mb-content {
  text-align: center;
  font-size: 30px;
  font-weight: 400;
  color: #333333;
  line-height: 44px;
  padding: 0 60px 0;
}
.mb-footer {
  margin: 53px 48px 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  .mb-confirm, .mb-cancel{
    width: 252px;
    height: 80px;
    line-height: 80px;
    font-size: 32px;
    border-radius: 4px;
    text-align: center;
    letter-spacing: 1px;
  }
  .mb-confirm{
    color: #fff;
    background: #3D81FF;
    box-shadow: 0px 12px 20px 0px rgba(63, 131, 255, 0.35);
  }
  .mb-cancel{
    background: #fff;
    color: #3D81FF;
    border: 1px solid #3D81FF;
  }
  button + button{
    margin-left: 20px;
  }
}
</style>
